// extracted by mini-css-extract-plugin
export var aircallIframe = "_di-3";
export var fabContainer = "_di-5";
export var fabRinging = "_di-6";
export var loadingOverlay = "_di-4";
export var pulse = "_di-7";
export var widgetContent = "_di-2";
export var widgetPanel = "_di-0";
export var widgetPanelExpanded = "_di-1";